import {
	createStore,
	createActionsHook,
	createContainer,
	createStateHook,
	type BoundActions,
	type ContainerComponent,
	type HookActionsFunction,
	type HookStateFunction,
	type StoreActionApi,
} from 'react-sweet-state';

export type OnboardingTakeoverType = 'v2-land' | 'v2-xflow' | 'nth-user';

type HTV2StoreContainerProps = {
	takeoverType: OnboardingTakeoverType;
	personalSpaceKey: string;
};

const HTV2Store = createStore({
	initialState: {
		takeoverType: 'v2-land',
		personalSpaceKey: '',
	},
	actions: {
		getIsLandTakeoverType:
			(): (({
				getState,
			}: StoreActionApi<{
				takeoverType: string;
				personalSpaceKey: string;
			}>) => boolean) =>
			({ getState }) =>
				getState().takeoverType === 'v2-land',
		getIsXflowTakeoverType:
			(): (({
				getState,
			}: StoreActionApi<{
				takeoverType: string;
				personalSpaceKey: string;
			}>) => boolean) =>
			({ getState }) =>
				getState().takeoverType === 'v2-xflow',
	},
	name: 'htv2Store',
});

export const useHTV2Actions: HookActionsFunction<
	BoundActions<
		{
			takeoverType: string;
			personalSpaceKey: string;
		},
		{
			getIsLandTakeoverType: () => ({
				getState,
			}: StoreActionApi<{
				takeoverType: string;
				personalSpaceKey: string;
			}>) => boolean;
			getIsXflowTakeoverType: () => ({
				getState,
			}: StoreActionApi<{
				takeoverType: string;
				personalSpaceKey: string;
			}>) => boolean;
		}
	>
> = createActionsHook(HTV2Store);
export const useHTV2State: HookStateFunction<
	{
		takeoverType: string;
		personalSpaceKey: string;
	},
	void
> = createStateHook(HTV2Store);

export const HTV2StoreContainer: ContainerComponent<HTV2StoreContainerProps> = createContainer(
	HTV2Store,
	{
		onInit:
			() =>
			({ setState }, { takeoverType, personalSpaceKey }) => {
				setState({ takeoverType, personalSpaceKey });
			},
	},
);
